import React from "react";
import AppRoutes from "./components/AppRoutes";
import { LanguageProvider } from "./contexts/LanguageContext";
import './App.css';
import './i18n';

const App = () => {
  return (
    <LanguageProvider>
      <AppRoutes />
    </LanguageProvider>
  );
}

export default App;
